/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type AiPlanningPlannerRedirectEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const aiPlanningPlannerRedirectEntrypoint: EntryPoint<
	AiPlanningPlannerRedirectEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<AiPlanningPlannerRedirectEntrypointComponent>(
		/* webpackChunkName: "async-ai-planning-planner-redirect" */ './AiPlanningPlannerRedirect.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => ({}),
});
